import { gql } from '@apollo/client';

export const GetOrganizationOwnerInvitationStatus = gql`
  query GetOrganizationOwnerInvitationStatus($token: String!) {
    organizationOwnerInvitationStatus(token: $token) {
      isValid
      isExpired
      accountCode
      accountLabel
      notifierFirstName
      notifierLastName
    }
  }
`;
